var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('paper-result-ai-h5',{attrs:{"btnColor":'linear-gradient(70deg, #00c2ff 0%, #00aaff 100%)'}})
}
var staticRenderFns = []

export { render, staticRenderFns }